import { css } from '@emotion/react';

import { tabletUp } from 'styles/utils';

import useIsEmbedded from 'hooks/useIsEmbedded';

import { headerHeightDesktop, headerHeightMobile } from './Navbar.config';

const navbarSpacerCss = css`
  height: ${headerHeightMobile}px;

  ${tabletUp} {
    height: ${headerHeightDesktop}px;
  }
`;

/**
 * A spacing element that goes along with pages that have a navbar.
 * It compensates the fact that the navbar is fixed and have height.
 * It will not be rendered on embedded-view.
 */
function NavbarSpacer() {
  const isEmbedded = useIsEmbedded();

  return !isEmbedded && <div css={navbarSpacerCss} />;
}

export default NavbarSpacer;
